export default __webpack_public_path__ + "static/hero-2-45abc7f022da0e46a8683dda514b344f.jpg";